import { useEffect, useState } from "react";
import closeIcon from "../../../assets/image/close.png";
import {
  useAddVideoMutation,
  useEditVideoMutation,
  useGetVideoQuery,
} from "../../../features/videos/videosApi";
import Error from "../../ui/Error";

export default function VideoModal({ open, control, task, videoId }) {
  const [checkVideoId, setCheckVideoId] = useState(false);
  const { data: video } =
    useGetVideoQuery(videoId, {
      skip: !checkVideoId,
    }) || {};

  const {
    title: initialTitle,
    description: initialDesc,
    url: initialUrl,
    views: initialViews,
    duration: initialDuration,
    id,
  } = video || {};

  useEffect(() => {
    if (videoId !== undefined) {
      setCheckVideoId(true);
    }
  }, [videoId]);

  useEffect(() => {
    setTitle(initialTitle);
    setDesc(initialDesc);
    setUrl(initialUrl);
    setViews(initialViews);
    setDuration(initialDuration);
  }, [initialTitle, initialDesc, initialUrl, initialViews, initialDuration]);

  const [title, setTitle] = useState(initialTitle || "");
  const [desc, setDesc] = useState(initialDesc || "");
  const [url, setUrl] = useState(initialUrl || "");
  const [views, setViews] = useState(initialViews || "");
  const [duration, setDuration] = useState(initialDuration || "");
  const [addVideo, { isLoading, isSuccess, isError, error }] =
    useAddVideoMutation();

  const [
    editVideo,
    {
      isLoading: editLoading,
      isSuccess: editIsSuccess,
      isError: editIsError,
      error: editError,
    },
  ] = useEditVideoMutation();

  useEffect(() => {
    if (isSuccess || editIsSuccess) {
      control();
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (task === "Add") {
      addVideo({
        data: {
          title,
          description: desc,
          url,
          views,
          duration,
          createdAt: new Date(),
        },
      });
    } else if (task === "Edit") {
      editVideo({
        id,
        data: {
          title,
          description: desc,
          url,
          views,
          duration,
          createdAt: new Date(),
        },
      });
    }
  };

  return (
    open && (
      <>
        <div
          onClick={control}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 text-white bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <button
            className="absolute close-icon bg-transparent text-white font-bold text-xl focus:outline-none"
            onClick={control}
          >
            <img src={closeIcon} alt="Close Icon" />
          </button>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            {task} Video
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="title" className="sr-only">
                  Title
                </label>
                <input
                  id="title"
                  name="title"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Video Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="description" className="sr-only">
                  Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  type="textarea"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Message"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="url" className="sr-only">
                  URL
                </label>
                <input
                  id="url"
                  name="url"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Video Url"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="views" className="sr-only">
                  Views
                </label>
                <input
                  id="views"
                  name="views"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Video Views e.g. 91.2K"
                  value={views}
                  onChange={(e) => setViews(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="duration" className="sr-only">
                  Duration
                </label>
                <input
                  id="duration"
                  name="duration"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Video Duration e.g. 31:30"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                disabled={isLoading || editLoading}
              >
                {task === "Add" ? "Add" : "Edit"} Video
              </button>
            </div>

            {isError && <Error message={error?.data} />}
            {editIsError && <Error message={editError?.data} />}
          </form>
        </div>
      </>
    )
  );
}
